import React, { useState } from 'react';
import styles from '../styles';

const BlogCard = ({ imgSrc, imgAlt, tag, title, excerpt }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      style={styles.blogCard}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img
        style={{ ...styles.blogImg, ...(hovered ? styles.blogImgHover : {}) }}
        src={imgSrc}
        alt={imgAlt}
      />
      <span style={styles.blogTag}>{tag}</span>
      <h3 style={styles.blogTitle}>{title}</h3>
      <p style={styles.blogExcerpt}>{excerpt}</p>
    </div>
  );
};

export default BlogCard;
